import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 italic text-center">Kanto el la filmo «Korŝira romanco»</p>

    
    <div class="poem">
      <p class="poem-block mb-3">
      Mi diros por la lasta foj’, <br/>
      Mi diros por la lasta foj’: <br/>
      Mi adiaŭas vin por ĉiam, <br/>
      Foriras mi – por alta ĝoj’ <br/>
      Aŭ por pereo en deliro. <br/>
      La amo via per dolor’ <br/>
      Min trafis – sed ne gravas tio. <br/>
      Pro am’ rompiĝis mia kor’, <br/>
      Kaj netuŝita restis via.
      </p>

      <p class="poem-block mb-3">
      Ankoraŭ viva estas mi, <br/>
      Sed brakoj falis sen espero; <br/>
      Disfalis senta harmoni’ <br/>
      Kaj min atendas nigra tero… <br/>
      Mi diros por la lasta foj’…
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Kaj finfine diros mi…'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['Z8VoWTDPVgY'],
    itemTranslator: `
      Teksto: B. Aĥmadulina, <br/>
      Muziko: A. Petrov, <br/>
      ${translator.esp}
    `
  }
}

export default item;